
<div class="elementCont" id="textboxcont-{{ indexofelement }}">
    <div class="form-group form-group-custom-for-element">
        <div class="overflowWrapAnywhere">
        <label for="" #addressLabel class="txt-bold" id="addressLabel-{{ indexofelement }}">Address</label>

        <div class="">
          <label for="" #addressLabel1   id="addressLabel1-{{ indexofelement }}" class="subLabel">Address 1</label>
        
      
  
      
        <input
          type="text"
          placeholder=""
          #addressInp1
          id="addressInp1-{{ indexofelement }}"
          class="form-control form-control-custom-for-element inpText inpBox"
        />
      </div>
        <div class="overflowWrapAnywhere mrgt-5" >
            <label for="" #addressLabel2  id="addressLabel2-{{ indexofelement }}" class="subLabel">Address 2 (Optional)</label>
        </div>
        <div >
        <input
          type="text"
          placeholder=""
          #addressInp2
          id="addressInp2-{{ indexofelement }}"
          class="form-control form-control-custom-for-element inpText inpBox"
        />
    </div>
    
        
            
    


           <div class="flex d-flex-custom-form d-flex-custom-form-768">
    
        <div class="overflowWrapAnywhere mrgt-5 w-100-custom-form">
            <label for="" #addressLabel  id="addressLabel-{{ indexofelement }}" class="subLabel">State</label>
        
          <input
            type="text"
            #addressStateInp
            id="addressStateInp-{{ indexofelement }}"
            class="form-control form-control-custom-for-element inpText inpBox"
            name="opn2"
          />
        </div>
    
    
        
        
          <div class="overflowWrapAnywhere mrgl-10-above768 mrgt-5 w-100-custom-form">
                <label for="" #addressLabel   id="addressLabel-{{ indexofelement }}" class="subLabel">City</label>
            
            
                <input
                type="text"
                placeholder=""
                #addressCityInp
                id="addressCityInp-{{ indexofelement }}"
                class="form-control form-control-custom-for-element inpText inpBox"
              
              
            />
            
          </div>
        
        
        <div class="overflowWrapAnywhere mrgl-10-above768 mrgt-5 w-100-custom-form">
            <label for="" #addressLabel   id="addressLabel-{{ indexofelement }}" class="subLabel">Zip/Postal</label>
        
          <input
            type="text"
            placeholder=""
            #addressPostalInp
            id="addressPostalInp-{{ indexofelement }}"
            class="form-control form-control-custom-for-element inpText inpBox"/>
        </div>
        
      </div>
      <div class="overflowWrapAnywhere mrgt-5 ">
        <label for="" #addressLabel  id="addressLabel-{{ indexofelement }}" class="subLabel">Country</label>
        
        <!-- <input 
            type="text"
            aria-placeholder="Country"
            #addressCountryInp
            id="addressCountryInp-{{ indexofelement }}"
            class="form-control form-control-custom-for-element inpText inpBox"
            name="opn1"
            
           /> -->


        <select 
        class="mrgt-5 form-control form-control-custom-for-element p-inputtext addressSelectebox" 
        name="opn1" #addressCountryInp 
        id="addressCountryInp-{{ indexofelement }}">
          <option value="US" selected>US</option>
          <option value="CANADA">CANADA</option>
        </select>
  </div>
        <div
          class="error-msg overflowWrapAnywhere"
          id="error-{{ indexofelement }}"
          #addresserror
        ></div>
      
    </div>
  </div>

  </div>
  
